var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDocumentLinesCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.5C21 16.299 16.299 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5ZM5 15.97V5.46997C5 4.91664 5.4288 4.46997 5.96 4.46997H7.4V3.96997C7.4 3.41664 7.8288 2.96997 8.36 2.96997H12.2C12.7312 2.96997 13.16 3.41664 13.16 3.96997V4.46997H14.6C15.1312 4.46997 15.56 4.91664 15.56 5.46997V10.9233H14.6V5.46997H13.16V6.96997H7.4V5.46997H5.96V15.97H11.24V16.97H5.96C5.4288 16.97 5 16.5233 5 15.97ZM8.36 3.96997H12.2V5.96997H8.36V3.96997ZM17 11.97H12.2V12.97H17V11.97ZM12.2 13.97H17V14.97H12.2V13.97ZM17 15.97H12.2V16.97H17V15.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDocumentLinesCircle);
export default __webpack_public_path__ + "static/media/ic-document-lines-circle.95441cb98ade6b30d90e19bb159f7da4.svg";
export { ForwardRef as ReactComponent };